import { Alert, AlertTitle, useFieldLabel } from "ra-friendsofbabba";
import React, { useMemo } from "react";

import { Typography } from "@material-ui/core";
import { get } from "lodash";
import moment from "moment";
import { useTranslate } from "react-admin";

const VerificationDateField = ({ record, source, ...props }) => {
  const fieldLabel = useFieldLabel(props);
  const translate = useTranslate();
  const { date, time } = useMemo(() => {
    const datetime = get(record, source, null);
    if (datetime === null) {
      return { date: null, time: null };
    }
    const dateFormat = translate("app.date_format.short");
    const date = moment(datetime).format(dateFormat);
    const time = moment(datetime).format("HH:mm");
    return { date, time };
  }, [record, source, translate]);
  if (date === null || time === null) {
    return null;
  }

  return (
    <Alert severity="info" color="info">
      <AlertTitle>{fieldLabel(`${source}.alert_title`)}</AlertTitle>
      <Typography
        dangerouslySetInnerHTML={{
          __html: translate(
            `resources.${props.resource}.fields.${source}.alert_message`,
            {
              date,
              time,
            }
          ),
        }}
      />
    </Alert>
  );
};
export default VerificationDateField;
